'use client'

import useEmblaCarousel from 'embla-carousel-react'
import { ImageComponent } from '@/components/ui/ImageComponent'

export function CareersImageCarousel({ images }: { images?: string[] }) {
    const [emblaRef] = useEmblaCarousel({
        align: 'start',
        loop: false,
        breakpoints: {
            '(min-width: 1024px)': { active: false }
        }
    })

    return (
        <div className="mt-10 lg:mt-16 overflow-hidden lg:overflow-visible" ref={emblaRef}>
            <div className="flex lg:grid lg:grid-cols-12 gap-4 lg:gap-6 h-[280px] lg:h-[480px]">
                {/* Large main image on the left for desktop */}
                <div className="relative flex-[0_0_85%] min-w-0 lg:flex-auto lg:col-span-8 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]">
                    <ImageComponent
                        src={images?.[0] ?? ''}
                        alt="Careers 1"
                        fill
                        className="object-cover"
                    />
                </div>

                {/* Two smaller images stacked on the right for desktop */}
                <div className="flex-[0_0_150%] min-w-0 lg:flex-auto lg:col-span-4 flex flex-row lg:flex-col gap-4 lg:gap-6">
                    <div className="relative flex-1 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]">
                        <ImageComponent
                        src={images?.[1] ?? ''}
                            alt="Careers 2"
                            fill
                            className="object-cover"
                        />
                    </div>
                    <div className="relative flex-1 w-full rounded-[24px] overflow-hidden bg-linear-to-b from-[#E5E5E5] to-[#999] shadow-[0_0_54px_0_rgba(0,0,0,0.02)]">
                        <ImageComponent
                            src={images?.[2] ?? ''}
                            alt="Careers 3"
                            fill
                            className="object-cover"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
